import clsx from 'clsx';

import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import MultiAssetRow from './MultiAssetRow';
import { getFilledMultiAssets } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  isCompletedOrAbove: boolean;
  reportAssets: any[];
}

const ReportMultiAssetsSection = ({
  isCompletedOrAbove,
  reportAssets,
}: Props) => {
  const filteredMultiAssets = getFilledMultiAssets(
    reportAssets,
    isCompletedOrAbove,
  );

  const showLocations = !isNilOrEmpty(filteredMultiAssets);

  return showLocations ? (
    <>
      <div className={classes.unifiedDataRow}>
        <div
          className={classes.dataCell}
        >{`Management Unit: ${filteredMultiAssets.managementUnit}`}</div>
        <div
          className={classes.dataCell}
        >{`County: ${filteredMultiAssets.county}`}</div>
        <div
          className={classes.dataCell}
        >{`Road Class: ${filteredMultiAssets.roadClass}`}</div>
      </div>
      <div className={classes.assetTableHeader}>
        <div className={classes.assetHeaderName}>Asset Name</div>
        <div className={classes.assetTableSub}>
          <div className={clsx(classes.assetHeaderCell, classes.assetRoute)}>
            Route
          </div>
          <div className={classes.assetHeaderCell}>Direction</div>
          <div className={classes.assetHeaderCell}>Start MP</div>
          <div className={classes.assetHeaderCell}>End MP</div>
        </div>
      </div>
      <div>
        {filteredMultiAssets?.multiAssets.map((rowMultiAsset, index) => (
          <MultiAssetRow key={index} rowMultiAsset={rowMultiAsset} />
        ))}
      </div>
    </>
  ) : (
    <div />
  );
};

export default ReportMultiAssetsSection;
